import { events } from '../names';
import { useSendEvent } from '../useSendEvent';

export const useSafeModeSwitched = () =>
	useSendEvent(events.nsfw.safeModeSwitched);
